import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.auth.login');
import { OnInit, EventEmitter, Output, ChangeDetectorRef as CDR } from '@angular/core';
import { Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";
import { ILoginFormData } from '../@types';

const SAVED_LOGIN_ID_KEY = 'inspectpro.login.savedId';
const AUTO_LOGIN_KEY = 'inspectpro.login.auto';
const AUTO_LOGIN_LIFETIME_DAYS = 30;
const LOGIN_FALLBACK_ERROR_MESSAGE = '로그인에 실패했습니다. 잠시 후 다시 시도해주세요.';

@Component({
    selector: 'wiz-component-auth-login',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.auth.login/view.scss */
:host {
  display: block;
}

.login-options {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.login-option {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 14px;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  background: #f8fafc;
  cursor: pointer;
  transition: border-color 0.18s ease, background 0.18s ease, box-shadow 0.18s ease;
}
.login-option:hover {
  border-color: #cbd5e1;
  background: #f1f5f9;
}
.login-option.active {
  border-color: #111827;
  background: #f3f4f6;
  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.08);
}

.login-option-checkbox {
  width: 16px;
  height: 16px;
  margin-top: 2px;
  accent-color: #111827;
  cursor: pointer;
  flex-shrink: 0;
}

.login-option-copy {
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
}

.login-option-title {
  font-size: 13px;
  font-weight: 600;
  color: #111827;
  line-height: 1.2;
}

.login-option-desc {
  font-size: 11px;
  color: #6b7280;
  line-height: 1.35;
}

.login-input,
.login-submit {
  scroll-margin-block: 18px;
}

button[type=submit]:active {
  transform: scale(0.98);
}
button[type=submit]:disabled {
  cursor: not-allowed;
  opacity: 0.65;
  transform: none;
}

:host-context(.auth-layout.keyboard-active) .login-header {
  margin-bottom: 14px !important;
}
:host-context(.auth-layout.keyboard-active) .login-header h2 {
  font-size: 20px;
  line-height: 1.35;
}
:host-context(.auth-layout.keyboard-active) .login-header p {
  margin-top: 2px !important;
  font-size: 12px;
  line-height: 1.35;
}
:host-context(.auth-layout.keyboard-active) .login-form > :not([hidden]) ~ :not([hidden]) {
  margin-top: 12px !important;
}
:host-context(.auth-layout.keyboard-active) .login-field > label,
:host-context(.auth-layout.keyboard-active) .login-password-label {
  margin-bottom: 4px !important;
}
:host-context(.auth-layout.keyboard-active) .login-input {
  min-height: 42px;
  padding-top: 10px !important;
  padding-bottom: 10px !important;
  border-radius: 10px;
}
:host-context(.auth-layout.keyboard-active) .login-options {
  gap: 8px;
}
:host-context(.auth-layout.keyboard-active) .login-option {
  align-items: center;
  gap: 8px;
  min-height: 38px;
  padding: 9px 10px;
  border-radius: 10px;
}
:host-context(.auth-layout.keyboard-active) .login-option-desc {
  display: none;
}
:host-context(.auth-layout.keyboard-active) .login-submit-row {
  padding-top: 0 !important;
}
:host-context(.auth-layout.keyboard-active) .login-submit {
  min-height: 42px;
  padding-top: 10px !important;
  padding-bottom: 10px !important;
  border-radius: 10px;
}
:host-context(.auth-layout.keyboard-active) .login-footer {
  display: none;
}

@media (orientation: landscape) and (max-height: 640px) {
  :host .login-header {
    margin-bottom: 14px !important;
  }
  :host .login-header h2 {
    font-size: 20px;
    line-height: 1.35;
  }
  :host .login-header p {
    margin-top: 2px !important;
    font-size: 12px;
    line-height: 1.35;
  }
  :host .login-form > :not([hidden]) ~ :not([hidden]) {
    margin-top: 12px !important;
  }
  :host .login-field > label,
  :host .login-password-label {
    margin-bottom: 4px !important;
  }
  :host .login-input {
    min-height: 42px;
    padding-top: 10px !important;
    padding-bottom: 10px !important;
    border-radius: 10px;
  }
  :host .login-options {
    gap: 8px;
  }
  :host .login-option {
    align-items: center;
    gap: 8px;
    min-height: 38px;
    padding: 9px 10px;
    border-radius: 10px;
  }
  :host .login-option-desc {
    display: none;
  }
  :host .login-submit-row {
    padding-top: 0 !important;
  }
  :host .login-submit {
    min-height: 42px;
    padding-top: 10px !important;
    padding-bottom: 10px !important;
    border-radius: 10px;
  }
  :host .login-footer {
    display: none;
  }
}
@media (max-width: 640px) {
  .login-options {
    grid-template-columns: 1fr;
  }
}`],
})
export class ComponentAuthLoginComponent implements OnInit {
    @Output() public changeMode = new EventEmitter<string>();

    /** 로그인 폼 데이터 - 타입 적용 */
    public data: ILoginFormData = {
        id: '',
        password: ''
    };

    public rememberId = false;
    public autoLogin = false;
    public submitting = false;
    public readonly autoLoginLifetimeDays = AUTO_LOGIN_LIFETIME_DAYS;

    constructor(@Inject( Service)         public service: Service,@Inject( CDR)         public ref: CDR,@Inject( Router    )         private router: Router    ) { }

    public async ngOnInit() {
        this.loadLoginPreferences();
        await this.service.render();
    }

    private loadLoginPreferences() {
        try {
            const savedId = localStorage.getItem(SAVED_LOGIN_ID_KEY);
            this.autoLogin = localStorage.getItem(AUTO_LOGIN_KEY) === 'true';

            if (savedId) {
                this.data.id = savedId;
                this.rememberId = true;
            }
        } catch (error) {
            console.error('Failed to load login preferences:', error);
        }
    }

    private persistLoginPreferences() {
        try {
            if (this.rememberId) localStorage.setItem(SAVED_LOGIN_ID_KEY, this.data.id);
            else localStorage.removeItem(SAVED_LOGIN_ID_KEY);

            localStorage.setItem(AUTO_LOGIN_KEY, this.autoLogin ? 'true' : 'false');
        } catch (error) {
            console.error('Failed to persist login preferences:', error);
        }
    }

    public onFieldFocus(event: FocusEvent) {
        const target = event.target as HTMLElement | null;
        if (!target) return;

        this.scrollLoginControlIntoView(target, 120);
        this.scrollLoginControlIntoView(target, 320);
    }

    private scrollLoginControlIntoView(target: HTMLElement, delay: number) {
        window.setTimeout(() => {
            target.scrollIntoView({ block: 'center', inline: 'nearest', behavior: 'smooth' });

            if (!target.matches('input[type="password"]')) return;
            const submit = target.closest('form')?.querySelector('.login-submit') as HTMLElement | null;
            submit?.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
        }, delay);
    }

    private async showLoginError(message: any) {
        await this.service.alert.show({
            message: message || LOGIN_FALLBACK_ERROR_MESSAGE,
            status: 'error',
            action: '확인',
            cancel: false
        });
    }

    public async login() {
        if (this.submitting) return;

        let user = JSON.parse(JSON.stringify(this.data));
        user.id = (user.id || '').trim();

        if (!user.id || !user.password) {
            await this.showLoginError('아이디와 비밀번호를 입력해주세요.');
            return;
        }

        this.submitting = true;
        await this.service.render();

        try {
            user.password = this.service.auth.hash(user.password);
            user.auto_login = this.autoLogin ? 'true' : 'false';

            let result = await wiz.call("login", user, { timeout: 10000 });
            let { code, data, message } = result || {};
            if (code == 200) {
                this.data.id = user.id;
                this.persistLoginPreferences();
                // Refresh auth state then navigate via Angular Router
                // Using Router.navigateByUrl avoids full page reload,
                // which fixes redirect issues in Capacitor Android WebView
                if (data && data.offline) {
                    this.service.auth.session = data;
                    this.service.auth.status = true;
                    this.service.auth.loading = true;
                    this.service.auth.timestamp = new Date().getTime();
                } else {
                    await this.service.auth.init();
                }
                this.router.navigateByUrl('/home');
                return;
            }

            await this.showLoginError(data || message);
        } catch (error) {
            console.error('Login failed:', error);
            await this.showLoginError(LOGIN_FALLBACK_ERROR_MESSAGE);
        } finally {
            this.submitting = false;
            await this.service.render();
        }
    }

    public gotoRegister() {
        this.changeMode.emit('register');
    }

    public gotoForgot() {
        this.changeMode.emit('forgot');
    }
}

export default ComponentAuthLoginComponent;